<template>
  <div class="dn-ad-preview view-ads">
    <h2>{{ title }}:</h2>
    <p>{{ id }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps({
  id: {
    type: String,
    default: null,
    required: true
  },
  title: {
    type: String,
    default: 'Ad',
    required: false
  }
});
</script>

<style lang="scss">
.dn-ad-preview {
  background: var(--color-advertising-banner-bg);
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: var(--row-gap);

  .top-ad-placeholder:has(&) {
    @media only screen and (width >= 1328px) {
      grid-area: 2 / 2 / 1 / 4;

      .article & {
        inline-size: var(--article-top-width);
        margin: var(--row-gap) auto 0;

        .dn-ad-preview {
          display: flex;
          padding: 0;
        }
      }
    }
  }

  &.narrow-ad {
    @media only screen and (width >= 1328px) {
      .article & {
        inline-size: var(--article-top-width);
        margin-inline: auto;
      }
    }
  }

  h2 {
    font-size: var(--typography-editorial-subhead-max-font-size);
    font-weight: var(--typography-editorial-subhead-max-font-weight);
    margin-bottom: 4px;
  }

  p {
    font-size: var(--typography-editorial-body-min-font-size);
  }

  &.left-sticky,
  &.right-sticky {
    display: none;
    transition: all 0.3s ease;

    @media only screen and (width >= 1328px) {
      position: sticky;
      display: flex;
      top: calc(var(--row-gap) * 4);
      z-index: 8;
    }

    &.dfp-ad::before {
      display: none;
    }
  }

  &.left-sticky {
    @media only screen and (width >= 1328px) {
      left: var(--ui-gap);
      justify-self: end;
    }
  }

  &.right-sticky {
    @media only screen and (width >= 1328px) {
      justify-self: start;
    }

    &.dfp-ad::before {
      display: none;
    }
  }

  &.full-width{
    grid-column: span 12;
  }

  &.dn-ma-frame {
    height: 180px;

    &-bottom-sticky {
      height: 80px;
    }
  }
}

.earpiece-preview {
  width: 300px;
  height: 100px;
}

.medium-rectangle-preview {
  width: 300px;
  height: 250px;
}

.skyscraper-preview {
  width: 300px;
  height: 600px;
}
</style>
